import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('boundaryMultiSelectPanelField');

    return {
        SEARCH: t('search')
    };
};

export default useTranslation;
